import { motion } from "framer-motion";

interface LogoProps {
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const Logo = ({ size = "md", className = "" }: LogoProps) => {
  const sizeMap = {
    xs: {
      wrap: "gap-1.5",
      mark: "h-6 w-6 rounded-[0.5rem] p-1",
      text: "text-sm",
      sub: "text-[0.42rem] tracking-[0.22em]",
    },
    sm: {
      wrap: "gap-2",
      mark: "h-8 w-8 rounded-[0.8rem] p-1.5",
      text: "text-lg",
      sub: "text-[0.55rem] tracking-[0.28em]",
    },
    md: {
      wrap: "gap-2.5",
      mark: "h-11 w-11 rounded-[1rem] p-2",
      text: "text-[1.75rem]",
      sub: "text-[0.62rem] tracking-[0.34em]",
    },
    lg: {
      wrap: "gap-3",
      mark: "h-14 w-14 rounded-[1.15rem] p-2.5",
      text: "text-[2.5rem] md:text-[3rem]",
      sub: "text-[0.72rem] tracking-[0.38em]",
    },
  };

  const currentSize = sizeMap[size];

  return (
    <motion.div
      className={`inline-flex items-center ${currentSize.wrap} ${className}`}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      aria-label="Stackly"
    >
      <div className={`relative shrink-0 bg-foreground text-background shadow-sm ${currentSize.mark}`}>
        <svg viewBox="0 0 48 48" className="h-full w-full" fill="none" aria-hidden="true">
          <rect x="8" y="9" width="24" height="8" rx="4" fill="currentColor" opacity="0.34" />
          <rect x="12" y="20" width="24" height="8" rx="4" fill="currentColor" opacity="0.62" />
          <rect x="16" y="31" width="24" height="8" rx="4" fill="currentColor" />
        </svg>
      </div>

      <div className="flex min-w-0 flex-col leading-none">
        <span className={`font-semibold tracking-[-0.06em] text-foreground ${currentSize.text}`}>
          Stackly
        </span>
      </div>
    </motion.div>
  );
};

export default Logo;
